<template>
    <div>
        <span class="data-label">
            <div class="ellipsis">{{ forceLabel ? forceLabel : label }}</div>
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <CopyLink
            :class="['data-value', canRemoveFavoriteClass]"
            :label="value"
            color="secondary"
            :url="link"
        />
    </div>
</template>

<script>
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';
import CopyLink from 'vcomponents/utilities/CopyLink.vue';

export default {
    components: {
        CopyLink,
    },
    mixins: [FavoriteHeaderMixins, DataValueMixin],
    props: {
        link: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.data-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
